import apiClient from "../utils/apiClient";

export default function DownloadInvoice({ subRequestId,prettyId }) {

    if(!subRequestId) {
        return;
    }

    const handleClickDownloadInvoice = async () => {
        try {
            const response = await apiClient.get(`/b-business-requests/subRequest/${subRequestId}/invoice`,{
                responseType: 'blob',
            });
            if(response?.data) {
                let fileURL = URL.createObjectURL(response.data);
                let fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.download = `Fanni-Business-Invoice-${prettyId}.pdf`;
                fileLink.target = '_blank';
                fileLink.click();
            } else {
            }
        } catch(err) {}
    }

    return (
        <div className="absolute bottom-[16px] end-[16px] cursor-pointer select-none text-success font-[600] text-[18px] leading-[27px]" onClick={handleClickDownloadInvoice}>
            <img src="/assets/images/download-invoice.svg" alt="" className="w-[24px] h-[24px] inline-block align-middle me-[4px]" />
            تحميل الفاتورة
        </div>
    )

}



